export default {
  init() {
    const debounce = (func, delay, { leading } = {}) => {
      let timerId;

      return (...args) => {
        if (!timerId && leading) {
          func(...args);
        }
        clearTimeout(timerId);

        timerId = setTimeout(() => func(...args), delay);
      };
    };
    const searchByName = (value, representantsNode) => {
      const niveauxGroups = Array.from(document.querySelectorAll('.js-niveau'));

      if (value.length > 2) {
        representantsNode.forEach((representantNode) => {
          const name = representantNode.querySelector('.representant__name').innerText.toLowerCase();
          if (!name.includes(value)) representantNode.classList.add('hidden');
        });
      } else {
        representantsNode.forEach((representantNode) => representantNode.classList.remove('hidden'));
      }
      niveauxGroups.forEach((niveau) => {
        const representantNodes = Array.from(niveau.querySelectorAll('.representant__list-item'));
        const hiddenChildrenCount = representantNodes.filter((representant) =>
          representant.classList.contains('hidden')
        ).length;
        representantNodes.length === hiddenChildrenCount
          ? niveau.classList.add('!hidden')
          : niveau.classList.remove('!hidden');
      });
    };
    const searchInput = document.getElementById('js-name-search');
    if (searchInput) {
      const representants = Array.from(document.querySelectorAll('.representant__list-item'));
      const debouncedSearch = debounce(searchByName, 200);
      searchInput.addEventListener('keyup', (e) => {
        const value = e.target.value;
        debouncedSearch(value, representants);
      });
      searchInput.addEventListener('search', () => {
        searchByName('', representants);
      });
    }

    // handle dropdown anchors on nos representants page
    const niveauxGoTo = document.getElementById('niveau-dropdown');
    if (niveauxGoTo) {
      const select = niveauxGoTo.querySelector('select');
      const submit = niveauxGoTo.querySelector('button');
      submit.addEventListener('click', () => {
        const value = select.value;
        window.location.hash = value;
      })
    }
  },
};
